import Mobile from "../components/Mobile";
import Header from "../components/Header";
import SideBar from "../components/SideBar";
import logo from "../assets/brand/logo.png";
import logo1 from "../assets/brand/images.png";
import closs from "../assets/brand/closs.png";
import bg from "../assets/brand/bggg.png";
import bg1 from "../assets/brand/bg1.gif";

function Web() {
  return (
    <div>
      <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center relative px-4 sm:px-8 md:px-16 lg:px-32">
        {/* Background Image */}
        <div
          className="absolute top-0 left-0 w-full h-full bg-cover bg-center opacity-15"
          style={{ backgroundImage: `url(${bg1})` }}
        ></div>

        {/* Logo and Title Section */}
        <div className="absolute top-20 z-20 text-center flex flex-col items-center ">
          {/* Logo */}
          <img src={logo} alt="Logo" className="h-28 sm:h-32 md:h-32 opacity-65 mb-1" />
          
          {/* Title */}
          <p className="text-white font-myraid text-lg sm:text-lg md:text-[16px] mt-1  bg-clip-text"
           style={{
            backgroundImage: "linear-gradient(to right, #fff, #fff, #dbbd6b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            padding: "0.2em 0", // Add padding to prevent clipping
          }}>
            EMLR KICUKIRO
          </p>
        </div>

        {/* Main Content */}
        <h1 
          className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-ettlora text-transparent bg-clip-text mb-8 z-10 mt-[100px]"
          style={{
            backgroundImage: "linear-gradient(to right, #dbbd6b, #dc331f, #dbbd6b)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            padding: "0.2em 0", // Add padding to prevent clipping
          }}
        >
          Coming Soon
        </h1>
        <p className="text-white font-maiandra text-lg sm:text-xl md:text-xl lg:text-xl bg-clip-text "
         style={{
            backgroundImage: "linear-gradient(to right, #ffefab, #fff173, #ffefab)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            padding: "0.2em 0", // Add padding to prevent clipping
          }}>
          Our website is currently under construction
        </p>
        <br />
        <br />
      </div>
    </div>
  );
}

export default Web;
